import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../../helpers/mainHelpers";
import DepatrmentsList from "./components/departments-list/DepartmentsList";
import {useDepartmentController} from "../../../controllers/departments-controller";
import DepartmentModal from "./components/department-modal/DepartmentModal";
import AddActionButton from "../../../components/action-buttons/addAction-button/AddActionButton";
import {useAuth} from "../../../context/authContext";
import ScrollToTopButton from "../../../components/main-buttons/scroll-button/ScrollToTopButton";
import React from "react";


const DepartmentsPage = () => {
  const {
    isLoading,
    confirmDeleteDepartment,
    toggleDepartmentModalOpen,
    isDepartmentModalOpen,
    createDepartment,
    departments, selectedDepartment, editButtonHandler, updateDepartment
  } = useDepartmentController()
  const {canManageContent} = useAuth()

  const headerActions = <>
    {canManageContent && <AddActionButton onClick={toggleDepartmentModalOpen}/>}
  </>

  return <>
    <div className="page_title">
      <PageHeader
        title={
          <div className="page-header_title">
            <div className="page_name">Відділення</div>
          </div>
        }
        extra={headerActions}
        onBack={navigateBackHandler}
      />
    </div>
    <div className="page_content">
      <DepatrmentsList isLoading={isLoading} editButtonHandler={editButtonHandler}
                       confirmDeleteDepartment={confirmDeleteDepartment}
                       departmentsList={departments}/>
      <ScrollToTopButton elementSelector={".page_content"}/>
    </div>
    {isDepartmentModalOpen &&
        <DepartmentModal updateDepartment={updateDepartment} createDepartment={createDepartment}
                         isModalOpen={isDepartmentModalOpen} isLoading={isLoading}
                         toggleModalOpen={toggleDepartmentModalOpen} selectedDepartment={selectedDepartment}/>}
  </>
}

export default DepartmentsPage